import type { FrequentRequest } from "state/members/frequentRequests";

/**
 * "{app} / {resource}" for a Frequent Access row, with the app dropped when it
 * would just repeat the resource. The duplicate check uses the resource's own
 * name: `resourceName` carries the tenant suffix, so "Microsoft" never equals
 * "Microsoft (Contoso UK)".
 */
export const frequentRowTitle = (
  fr: Pick<FrequentRequest, "appName" | "resourceName" | "rawResourceName">,
): { app: string | null; resource: string } => {
  const raw = fr.rawResourceName ?? fr.resourceName;
  const showApp = Boolean(fr.appName) && fr.appName !== raw;
  return { app: showApp ? fr.appName : null, resource: fr.resourceName };
};
